import { type ChatbotMessage, MessageType } from '../types/messageTypes'

export const getIsRegenerateEnabled = (
	chatHistoryMessages: ChatbotMessage[]
): boolean => {
	const lastMessage = chatHistoryMessages[chatHistoryMessages.length - 1]
	return lastMessage?.type === MessageType.FashionAssistant
}
